export default {
  selectedGroup: "Selected Group",
  userFallback: "User",
  welcome: "Welcome, {name}",
  roleLabel: "Role",
  adminArea: "Admin Area",
  switchSection: "Switch",
  backToMember: "Back to Member",
  actions: {
    openMenu: "Open menu",
    closeMenu: "Close menu",
    logout: "Logout",
  },
  roles: {
    owner: "Owner",
    admin: "Administrator",
    treasurer: "Treasurer",
    member: "Member",
  },
};
